import apiClient from './api.service';
import {
  QuestionGroupDetail,
  QuestionGroupListResponse,
  QuestionGroupCreatePayload,
  QuestionGroupUpdatePayload,
  QuestionGroupReorderPayload,
  PersonalizedGroupSequence,
} from '../types/survey-question-group.types';

class SurveyQuestionGroupService {
  // ─── Admin ──────────────────────────────────────────────────────────────

  async listGroupsAdmin(surveyId: string): Promise<QuestionGroupDetail[]> {
    const res = await apiClient.get<{ data: QuestionGroupListResponse }>(
      `/api/admin/surveys/${surveyId}/question-groups`,
    );
    return res.data.data.items;
  }

  async createGroupAdmin(surveyId: string, payload: QuestionGroupCreatePayload): Promise<QuestionGroupDetail> {
    const res = await apiClient.post<{ data: QuestionGroupDetail }>(
      `/api/admin/surveys/${surveyId}/question-groups`,
      payload,
    );
    return res.data.data;
  }

  async updateGroupAdmin(surveyId: string, groupId: string, payload: QuestionGroupUpdatePayload): Promise<QuestionGroupDetail> {
    const res = await apiClient.patch<{ data: QuestionGroupDetail }>(
      `/api/admin/surveys/${surveyId}/question-groups/${groupId}`,
      payload,
    );
    return res.data.data;
  }

  async deleteGroupAdmin(surveyId: string, groupId: string): Promise<void> {
    await apiClient.delete(`/api/admin/surveys/${surveyId}/question-groups/${groupId}`);
  }

  async reorderGroupsAdmin(surveyId: string, payload: QuestionGroupReorderPayload): Promise<QuestionGroupDetail[]> {
    const res = await apiClient.put<{ data: QuestionGroupListResponse }>(
      `/api/admin/surveys/${surveyId}/question-groups/order`,
      payload,
    );
    return res.data.data.items;
  }

  // ─── Contractor ─────────────────────────────────────────────────────────

  async listGroupsContractor(surveyId: string): Promise<QuestionGroupDetail[]> {
    const res = await apiClient.get<{ data: QuestionGroupListResponse }>(
      `/api/contractor/surveys/${surveyId}/question-groups`,
    );
    return res.data.data.items;
  }

  async createGroupContractor(surveyId: string, payload: QuestionGroupCreatePayload): Promise<QuestionGroupDetail> {
    const res = await apiClient.post<{ data: QuestionGroupDetail }>(
      `/api/contractor/surveys/${surveyId}/question-groups`,
      payload,
    );
    return res.data.data;
  }

  async updateGroupContractor(surveyId: string, groupId: string, payload: QuestionGroupUpdatePayload): Promise<QuestionGroupDetail> {
    const res = await apiClient.patch<{ data: QuestionGroupDetail }>(
      `/api/contractor/surveys/${surveyId}/question-groups/${groupId}`,
      payload,
    );
    return res.data.data;
  }

  async deleteGroupContractor(surveyId: string, groupId: string): Promise<void> {
    await apiClient.delete(`/api/contractor/surveys/${surveyId}/question-groups/${groupId}`);
  }

  async reorderGroupsContractor(surveyId: string, payload: QuestionGroupReorderPayload): Promise<QuestionGroupDetail[]> {
    const res = await apiClient.put<{ data: QuestionGroupListResponse }>(
      `/api/contractor/surveys/${surveyId}/question-groups/order`,
      payload,
    );
    return res.data.data.items;
  }

  // ─── Participant ─────────────────────────────────────────────────────────

  async getPersonalizedSequence(surveyId: string): Promise<PersonalizedGroupSequence | null> {
    try {
      const res = await apiClient.get<{ data: PersonalizedGroupSequence }>(
        `/api/me/surveys/${surveyId}/question-groups`,
      );
      if (res.status === 204) return null;
      return res.data.data;
    } catch (err: any) {
      if (err?.response?.status === 204) return null;
      throw err;
    }
  }
}

export const surveyQuestionGroupService = new SurveyQuestionGroupService();
